import vue3lottie from 'vue3-lottie'
import type { Plugin } from 'vue'

export const lottiePlugin: Plugin = {
  install(app, _options) {
    app.use(vue3lottie, { name: 'Vue3Lottie' })
  }
}
